import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Route } from "react-router-dom";

import { Provider } from "react-redux";
import ReactGA from 'react-ga';

import "./styles/index.css";
import App from "./App";

import registerServiceWorker from "./registerServiceWorker";
import store from "./store";
import {auth} from "./firebase/firebase";
import reducerRegistry from "./reducers/reducerRegistry";
import {composeWithDevTools} from "redux-devtools-extension";
window.$ = window.jQuery = require("jquery");
window.Popper = require("popper.js");

require("dotenv").config();
require("bootstrap/dist/js/bootstrap");

/*
const store = createStore(
    rootReducer,
    composeWithDevTools(applyMiddleware(thunk))
);

store.asyncReducers={};
*/

const analyticsTracking = () => {
    ReactGA.pageview(window.location.pathname + window.location.search);
};
const createStore=store;


ReactDOM.render(
    <BrowserRouter onUpdate={analyticsTracking}>
        <Provider store={createStore}>
            <Route component={App} />
        </Provider>
    </BrowserRouter>,
    document.getElementById("root")
);


registerServiceWorker();
auth();




// WEBPACK FOOTER //
// ./src/index.js